import { render, staticRenderFns } from "./wizardot7printemail.vue?vue&type=template&id=1c81504e&scoped=true&"
import script from "./wizardot7printemail.vue?vue&type=script&lang=js&"
export * from "./wizardot7printemail.vue?vue&type=script&lang=js&"
import style0 from "./wizardot7printemail.vue?vue&type=style&index=0&id=1c81504e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81504e",
  null
  
)

export default component.exports